import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ChildAuthGuard } from './guards/child-auth.guard';

console.log('Loading app routes configuration');

// Fix mail routes to work with the application's layout structure
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component')
      .then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component')
      .then(m => m.ProfileComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadComponent: () => import('./features/account/account.component')
      .then(m => m.AccountComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadComponent: () => import('./features/settings/settings.component')
      .then(m => m.SettingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-child',
    loadComponent: () => import('./features/child/add-child/add-child.component')
      .then(m => m.AddChildComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-child/:id',
    loadComponent: () => import('./features/child/edit-child/edit-child.component')
      .then(m => m.EditChildComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'child/:id',
    loadComponent: () => import('./features/child/child-details/child-details.component')
      .then(m => m.ChildDetailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'chores',
    loadComponent: () => import('./features/chores/chores.component').then(m => m.ChoresComponent),
    canActivate: [AuthGuard, ChildAuthGuard]
  },
  {
    path: 'add-chore',
    loadComponent: () => import('./features/chores/add-edit-chore/add-edit-chore.component').then(m => m.AddEditChoreComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-chore/:id',
    loadComponent: () => import('./features/chores/add-edit-chore/add-edit-chore.component').then(m => m.AddEditChoreComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'prizes',
    loadComponent: () => import('./features/prizes/prizes.component').then(m => m.PrizesComponent),
    canActivate: [AuthGuard, ChildAuthGuard]
  },
  {
    path: 'sticker-book',
    loadComponent: () => import('./features/sticker-book/sticker-book.component').then(m => m.StickerBookComponent),
    canActivate: [AuthGuard, ChildAuthGuard]
  },
  {
    path: 'coloring-book',
    loadComponent: () => import('./features/coloring-book/coloring-book.component').then(m => m.ColoringBookComponent),
    canActivate: [AuthGuard, ChildAuthGuard]
  },
  {
    path: 'mail',
    loadComponent: () => {
      console.log('Attempting to lazy load mail component');
      return import('./features/mail/mail.component')
        .then(m => {
          console.log('Mail component module loaded successfully:', m);
          console.log('Mail component class available:', m.MailComponent);
          return m.MailComponent;
        })
        .catch(error => {
          console.error('Error loading mail component:', error);
          throw error;
        });
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'bank',
    loadComponent: () => import('./features/bank/bank.component').then(m => m.BankComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'games',
    loadComponent: () => import('./features/games/games.component').then(m => m.GamesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'alexa-settings',
    loadComponent: () => import('./features/alexa-settings/alexa-settings.component').then(m => m.AlexaSettingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadComponent: () => import('./features/auth/alexa-auth/alexa-auth.component').then(m => m.AlexaAuthComponent)
  },
  {
    path: 'test',
    loadComponent: () => import('./features/test/test.component').then(m => m.TestComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
